import { render } from "./Score.vue?vue&type=template&id=7f0824e9&ts=true"
import script from "./Score.vue?vue&type=script&lang=ts"
export * from "./Score.vue?vue&type=script&lang=ts"

import "./Score.vue?vue&type=style&index=0&id=7f0824e9&lang=scss"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__